import { render, staticRenderFns } from "./FloatBtn.vue?vue&type=template&id=4bbb9ec8&"
import script from "./FloatBtn.vue?vue&type=script&lang=js&"
export * from "./FloatBtn.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "FloatBtn.vue"
export default component.exports